export class SellerPJDataPayload {
  corporateName: string;
  documentNumber?: string;
  companyType: string;
  lastChangeDate: string;
  hasDeclaration: boolean;
  contact: Contact;
  address: Address;
  representatives: Representa[];
  attorneys?: Attorney[];
  bankAccounts: BankAccount[];

  constructor() {
    this.contact = new Contact();
    this.address = new Address();
    this.representatives = new Array<Representa>();
    this.bankAccounts = new Array<BankAccount>();
  }
}

export class Contact {
  email: string;
  phone: string;
}

export class Address {
  zipCode: string;
  street: string;
  number: string;
  complement: string;
  district: string;
  city: string;
  state: string;
}

export class Representa {
  name: string;
  documentNumber: string;
}

export class Attorney {
  name: string;
  documentNumber: string;
  email: string;
  phone: string;
  type?: string;
}

export class BankAccount {
  name?: string;
  documentNumber: string;
  bankNumber: string;
  accountType: string;
  agencyNumber: string;
  accountNumber: string;
  accountDigit: string;
}
